let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cdnZw")).then(() => parcelRequire('fnaab'));